import { createContext as e, useContext as t, useEffect as n, useRef as r, useState as i } from "react";
import { DsCard as a, DsCell as o, DsCheckbox as s, DsChip as c, DsChipGroup as l, DsColumn as u, DsDateRangePicker as d, DsPagination as f, DsRow as p, DsSearchField as m, DsSelectCompact as h, DsSelectItem as g, DsTable as _, DsTableBody as v, DsTableHeader as y } from "@frontends/ds";
import { cn as b } from "@frontends/util-cn";
import { jsx as x, jsxs as S } from "react/jsx-runtime";
import { parseDate as C, toCalendarDate as w } from "@internationalized/date";
import { useTranslation as T } from "react-i18next";
import { UiKitEmptyState as E } from "@frontends/ui-kit";
//#region src/lib/config/customFilter.ts
function D(e) {
	return {
		...e,
		type: "custom"
	};
}
//#endregion
//#region src/lib/hooks/useDataTableSurface.ts
var O = e("card");
function k() {
	return t(O);
}
//#endregion
//#region src/lib/render/DataTableFrame.tsx
function A({ children: e, className: t, surface: n = "card" }) {
	return /* @__PURE__ */ x(O.Provider, {
		value: n,
		children: n === "card" ? /* @__PURE__ */ x(a, {
			padding: "none",
			className: t,
			children: e
		}) : /* @__PURE__ */ x("div", {
			className: b("flex min-w-0 flex-col gap-4", t),
			children: e
		})
	});
}
//#endregion
//#region src/lib/filters/FilterCheckbox.tsx
function j({ value: e, config: t, onChange: n }) {
	return /* @__PURE__ */ x(s, {
		isSelected: e,
		onChange: n,
		children: t.label
	});
}
//#endregion
//#region src/lib/filters/FilterChips.tsx
function M({ value: e, config: t, onChange: n }) {
	function r(e) {
		let [t] = [...e];
		t !== void 0 && n(String(t));
	}
	return /* @__PURE__ */ x(l, {
		"aria-label": t.label,
		selectionMode: "single",
		disallowEmptySelection: !0,
		selectedKeys: [e],
		onSelectionChange: r,
		className: "flex-auto",
		children: t.options.map((e) => /* @__PURE__ */ x(c, {
			id: e.value,
			children: e.label
		}, e.value))
	});
}
//#endregion
//#region src/lib/filters/FilterDateRange.tsx
function ee({ value: e, config: t, onChange: n }) {
	function r(e) {
		if (e === null) {
			n(null);
			return;
		}
		n({
			start: w(e.start),
			end: w(e.end)
		});
	}
	return /* @__PURE__ */ x(d, {
		"aria-label": t.label,
		value: e,
		onChange: r
	});
}
var te = {
	filters: { search: { placeholder: "Search" } },
	states: {
		error: {
			description: "Something went wrong while loading this table.",
			title: "Couldn't load data"
		},
		noResults: {
			action: "Clear filters",
			description: "Try changing the filters.",
			title: "Nothing found"
		},
		retry: "Retry"
	}
}, N = "data-table-common", ne = ["asc", "desc"], P = "page", F = "sort", re = "From", I = "en-GB";
function L(e, t) {
	let n = t.split(".").reduce((e, t) => {
		if (e && typeof e == "object") return e[t];
	}, e);
	return typeof n == "string" ? n : t;
}
function ie(e, t) {
	return t ? e.replace(/\{\{(\w+)\}\}/g, (e, n) => n in t ? String(t[n]) : e) : e;
}
var ae = {
	language: I,
	t: ((e, t) => ie(L(te, e), t))
};
function R() {
	let e = T(N, { useSuspense: !1 });
	return e.ready ? {
		language: e.i18n.language,
		t: e.t
	} : ae;
}
//#endregion
//#region src/lib/url/filterParams.ts
function z(e) {
	return [`${e}${re}`, `${e}To`];
}
function oe(e, t) {
	return t.type === "dateRange" ? z(e) : [e];
}
function se(e, t) {
	let n = t.options.find((t) => t.value === e);
	return n === void 0 ? t.defaultValue : n.value;
}
function ce(e, t) {
	return e === "1" || e !== "0" && t.defaultValue;
}
function B(e, t) {
	let n = e.trim();
	return n.length < (t ?? 1) ? "" : n;
}
function V(e, t) {
	return e === null ? t.defaultValue : B(e, t.minLength);
}
function H(e) {
	try {
		return C(e);
	} catch {
		return null;
	}
}
function U(e, t, n) {
	let [r, i] = z(t), a = e.get(r), o = e.get(i);
	if (a === "" && o === "") return null;
	if (a === null || o === null) return n.defaultValue;
	let s = H(a), c = H(o);
	return s === null || c === null || s.compare(c) > 0 ? n.defaultValue : {
		start: s,
		end: c
	};
}
function W(e, t, n) {
	switch (n.type) {
		case "chips":
		case "select": return se(e.get(t), n);
		case "checkbox": return ce(e.get(t), n);
		case "search": return V(e.get(t), n);
		case "dateRange": return U(e, t, n);
		case "custom": return n.parse(e.get(t));
		default: return;
	}
}
function G(e, t) {
	let [n, r] = z(e);
	return t === null ? {
		[n]: "",
		[r]: ""
	} : {
		[n]: t.start.toString(),
		[r]: t.end.toString()
	};
}
function K(e, t, n) {
	switch (t.type) {
		case "chips":
		case "select": return { [e]: n };
		case "checkbox": return { [e]: n === !0 ? "1" : "0" };
		case "search": return { [e]: n.trim() };
		case "dateRange": return G(e, n);
		case "custom": {
			let r = t.serialize(n);
			return r === null ? {} : { [e]: r };
		}
		default: return {};
	}
}
function le(e, t) {
	return new URLSearchParams(e).toString() === new URLSearchParams(t).toString();
}
function q(e, t, n) {
	let r = K(e, t, n);
	return le(r, K(e, t, t.defaultValue)) ? {} : r;
}
function ue(e, t, n) {
	return Object.keys(q(e, t, n)).length > 0;
}
//#endregion
//#region src/lib/filters/FilterSearch.tsx
function de({ value: e, config: t, onChange: a }) {
	let { t: o } = R(), [s, c] = i(e), [l, u] = i(e), d = r(a), f = r(null);
	d.current = a, e !== l && (u(e), e !== f.current && c(e));
	let { minLength: p } = t;
	n(() => {
		let t = B(s, p);
		if (t === e) return;
		let n = setTimeout(() => {
			f.current = t, d.current(t);
		}, 300);
		return () => clearTimeout(n);
	}, [
		s,
		e,
		p
	]), n(() => {
		f.current = null;
	}, [e]);
	function h() {
		e !== "" && (f.current = "", d.current(""));
	}
	return /* @__PURE__ */ x(m, {
		"aria-label": t.label,
		placeholder: t.placeholder ?? o("filters.search.placeholder"),
		width: t.width,
		value: s,
		onChange: c,
		onClear: h
	});
}
//#endregion
//#region src/lib/filters/FilterSelect.tsx
function fe({ value: e, config: t, onChange: n }) {
	function r(e) {
		let r = t.options.find((t) => t.value === e);
		r !== void 0 && n(r.value);
	}
	return /* @__PURE__ */ x(h, {
		"aria-label": t.label,
		value: e,
		isFilled: e !== t.defaultValue,
		onChange: r,
		children: t.options.map((e) => /* @__PURE__ */ x(g, {
			id: e.value,
			children: e.label
		}, e.value))
	});
}
//#endregion
//#region src/lib/filters/renderFilter.tsx
function pe({ value: e, config: t, onChange: n }) {
	switch (t.type) {
		case "chips": return /* @__PURE__ */ x(M, {
			value: e,
			config: t,
			onChange: n
		});
		case "select": return /* @__PURE__ */ x(fe, {
			value: e,
			config: t,
			onChange: n
		});
		case "checkbox": return /* @__PURE__ */ x(j, {
			value: e,
			config: t,
			onChange: n
		});
		case "search": return /* @__PURE__ */ x(de, {
			value: e,
			config: t,
			onChange: n
		});
		case "dateRange": return /* @__PURE__ */ x(ee, {
			value: e,
			config: t,
			onChange: n
		});
		case "custom": return t.render({
			value: e,
			onChange: n
		});
		default: return null;
	}
}
//#endregion
//#region src/lib/render/DataTableToolbar.tsx
function J({ live: e, name: t }) {
	let n = e.config.filters?.[t];
	return n === void 0 ? null : pe({
		value: e.state.filters[t],
		config: n,
		onChange: (n) => e.setFilter(t, n)
	});
}
function me({ live: e, children: t, className: n }) {
	let r = k(), i = e.config.filters ?? {}, a = Object.keys(i), o = a.findIndex((e) => i[e]?.type === "search"), s = o === -1 ? void 0 : i[a[o]], c = s?.type === "search" && s.isStandalone === !0, l = o === -1 || c ? void 0 : a[o + 1], u = l !== void 0 || c;
	return /* @__PURE__ */ S("div", {
		className: b("flex flex-wrap items-center gap-x-8 gap-y-4", r === "card" && "border-b border-borderTertiary p-4", n),
		children: [a.map((t, n) => l !== void 0 && n === o + 1 ? null : u && n === o ? /* @__PURE__ */ S("div", {
			className: "flex min-w-0 flex-auto flex-wrap items-center gap-4",
			children: [/* @__PURE__ */ x(J, {
				live: e,
				name: t
			}), l !== void 0 && /* @__PURE__ */ x(J, {
				live: e,
				name: l
			})]
		}, t) : /* @__PURE__ */ x(J, {
			live: e,
			name: t
		}, t)), t]
	});
}
//#endregion
//#region src/lib/state/sortDescriptor.ts
function he(e) {
	return {
		column: e.by,
		direction: e.order === "asc" ? "ascending" : "descending"
	};
}
function ge(e, t) {
	let n = t.find((t) => t === e.column);
	return n === void 0 ? null : {
		by: n,
		order: e.direction === "ascending" ? "asc" : "desc"
	};
}
function _e(e, t, n) {
	return t.by === e.by && e.order === "desc" && t.order === "asc" && t.by !== n.by ? n : t;
}
//#endregion
//#region src/lib/state/status.ts
function Y(e, t) {
	return e.isError && e.data === void 0 ? "error" : e.isPending || e.data === void 0 || e.isPlaceholderData === !0 ? "loading" : e.data.total === 0 ? t ? "noResults" : "empty" : "ready";
}
//#endregion
//#region src/lib/state/tableState.ts
function X(e) {
	return e.flatMap((e) => e.isSortable ? [e.id] : []);
}
function ve(e, t) {
	return Object.fromEntries(Object.entries(t).map(([t, n]) => [t, n.isScope ? e[t] : n.defaultValue]));
}
function ye(e, t, n) {
	return {
		...e,
		filters: {
			...e.filters,
			[t]: n
		},
		page: 1
	};
}
function be(e, t) {
	return {
		...e,
		sort: t,
		page: 1
	};
}
function xe(e, t) {
	return {
		...e,
		page: t
	};
}
function Se(e, t) {
	return {
		...e,
		filters: ve(e.filters, t),
		page: 1
	};
}
function Ce(e, t) {
	return Object.entries(t).some(([t, n]) => !n.isScope && ue(t, n, e.filters[t]));
}
function we(e, t) {
	return {
		limit: t,
		offset: t * (e.page - 1),
		sortBy: e.sort.by,
		sortOrder: e.sort.order
	};
}
//#endregion
//#region src/lib/render/SkeletonBar.tsx
function Z({ className: e }) {
	return /* @__PURE__ */ x("div", {
		"aria-hidden": "true",
		className: b("animate-pulse rounded-sm bg-backgroundHover", e)
	});
}
//#endregion
//#region src/lib/render/CellSkeleton.tsx
var Q = [
	"w-14.5",
	"w-12",
	"w-20.5"
];
function Te({ rowIndex: e, shape: t = "line" }) {
	return t === "pill" ? /* @__PURE__ */ x(Z, { className: `h-5 rounded-full ${Q[e % Q.length]}` }) : /* @__PURE__ */ S("div", {
		className: "flex flex-col",
		children: [/* @__PURE__ */ x("div", {
			className: "flex h-5 flex-col justify-center",
			children: /* @__PURE__ */ x(Z, { className: "h-2.5" })
		}), t === "twoLines" && /* @__PURE__ */ x("div", {
			className: "flex h-4 flex-col justify-center",
			children: /* @__PURE__ */ x(Z, { className: "h-2" })
		})]
	});
}
//#endregion
//#region src/lib/render/ErrorState.tsx
function Ee({ onRetry: e }) {
	let { t } = R();
	return /* @__PURE__ */ x(E, {
		align: "center",
		icon: "database-x",
		title: t("states.error.title"),
		description: t("states.error.description"),
		actionLabel: t("states.retry"),
		onAction: e
	});
}
//#endregion
//#region src/lib/render/PaginationSkeleton.tsx
function De({ className: e }) {
	return /* @__PURE__ */ S("div", {
		"aria-hidden": "true",
		className: b("flex items-center justify-between p-4", e),
		children: [/* @__PURE__ */ x("div", {
			className: "flex h-5 flex-col justify-center",
			children: /* @__PURE__ */ x(Z, { className: "h-2.5 w-50" })
		}), /* @__PURE__ */ x(Z, { className: "h-9 w-60 rounded-lg" })]
	});
}
//#endregion
//#region src/lib/render/DataTableView.tsx
var Oe = "py-21", $ = "py-17", ke = "border-t border-borderSecondary", Ae = "p-0";
function je({ live: e, query: t, emptyState: n, noResultsState: r, className: i, headerVariant: a }) {
	let { language: s, t: c } = R(), l = k() === "card", d = Y(t, e.hasActiveFilters);
	if (d === "empty") return /* @__PURE__ */ x("div", {
		className: b(Oe, i),
		children: /* @__PURE__ */ x(E, { ...n })
	});
	let { columns: m, getRowHref: h, getRowKey: g, onRowAction: C, rowDependencies: w = [] } = e.config, T = X(m), D = d === "ready" ? t.data?.data ?? [] : [], O = [
		m,
		s,
		...w
	], A = l ? ke : Ae;
	function j() {
		return d === "error" ? /* @__PURE__ */ x("div", {
			className: $,
			children: /* @__PURE__ */ x(Ee, { onRetry: () => void t.refetch() })
		}) : /* @__PURE__ */ x("div", {
			className: $,
			children: /* @__PURE__ */ x(E, {
				icon: "shapes",
				title: c("states.noResults.title"),
				description: c("states.noResults.description"),
				actionLabel: c("states.noResults.action"),
				...r,
				actionButton: "plain",
				onAction: e.resetFilters
			})
		});
	}
	return /* @__PURE__ */ S("div", {
		"aria-busy": d === "loading",
		className: b("flex min-w-0 flex-col", !l && "gap-4", i),
		children: [
			/* @__PURE__ */ S(_, {
				"aria-label": e.config["aria-label"],
				variant: l ? "plain" : "raised",
				sortDescriptor: he(e.state.sort),
				onSortChange: (t) => {
					let n = ge(t, T);
					n !== null && e.setSort(_e(e.state.sort, n, e.config.defaultSort));
				},
				children: [/* @__PURE__ */ x(y, {
					columns: m,
					variant: a,
					children: (e) => /* @__PURE__ */ x(u, {
						id: e.id,
						align: e.align,
						allowsSorting: e.isSortable,
						fitContent: e.fitContent,
						isRowHeader: e.isRowHeader,
						minWidth: e.minWidth,
						width: e.width,
						shouldFitLabel: !0,
						children: e.label
					})
				}), d === "loading" ? /* @__PURE__ */ x(v, { children: Array.from({ length: e.pageSize }, (e, t) => /* @__PURE__ */ x(p, {
					id: `skeleton-${t}`,
					children: m.map((e) => /* @__PURE__ */ x(o, {
						align: e.align,
						children: /* @__PURE__ */ x(Te, {
							rowIndex: t,
							shape: e.skeleton
						})
					}, e.id))
				}, t)) }, "skeleton") : /* @__PURE__ */ x(v, {
					items: D,
					dependencies: O,
					renderEmptyState: j,
					children: (e) => /* @__PURE__ */ x(p, {
						id: g(e),
						columns: m,
						href: h?.(e),
						onAction: C === void 0 ? void 0 : () => C(e),
						children: (t) => /* @__PURE__ */ x(o, {
							align: t.align,
							...t.cellProps?.(e),
							children: t.cell(e)
						})
					})
				}, "rows")]
			}),
			d === "ready" && /* @__PURE__ */ x(f, {
				className: A,
				count: t.data?.total ?? 0,
				pageSize: e.pageSize,
				page: e.state.page,
				onPageChange: e.setPage
			}),
			d === "loading" && /* @__PURE__ */ x(De, { className: A })
		]
	});
}
//#endregion
//#region src/lib/render/buildComponents.tsx
function Me(e) {
	function t({ name: t }) {
		return /* @__PURE__ */ x(J, {
			live: e.current,
			name: t
		});
	}
	function n(t) {
		return /* @__PURE__ */ x(me, {
			live: e.current,
			...t
		});
	}
	function r(t) {
		return /* @__PURE__ */ x(je, {
			live: e.current,
			...t
		});
	}
	return {
		Filter: t,
		Frame: A,
		Table: r,
		Toolbar: n
	};
}
//#endregion
//#region src/lib/url/tableParams.ts
function Ne(e) {
	let t = Number(e);
	return !Number.isInteger(t) || t < 1 ? 1 : t;
}
function Pe(e, t) {
	if (e === null) return t.defaultSort;
	let [n, r] = e.split(":"), i = t.sortableIds.find((e) => e === n), a = ne.find((e) => e === r);
	return i === void 0 || a === void 0 ? t.defaultSort : {
		by: i,
		order: a
	};
}
function Fe(e, t) {
	let n = {};
	for (let [r, i] of Object.entries(t.filters)) n[r] = W(e, r, i);
	return {
		page: Ne(e.get(P)),
		sort: Pe(e.get(F), t),
		filters: n
	};
}
function Ie(e) {
	return [
		P,
		F,
		...Object.entries(e.filters).flatMap(([e, t]) => oe(e, t))
	];
}
function Le(e, t) {
	let n = {}, { defaultSort: r } = t;
	e.page > 1 && (n[P] = String(e.page)), (e.sort.by !== r.by || e.sort.order !== r.order) && (n[F] = `${e.sort.by}:${e.sort.order}`);
	for (let [r, i] of Object.entries(t.filters)) Object.assign(n, q(r, i, e.filters[r]));
	return n;
}
function Re(e, t, n) {
	let r = new URLSearchParams(e);
	for (let e of Ie(n)) r.delete(e);
	for (let [e, i] of Object.entries(Le(t, n))) r.set(e, i);
	return r;
}
//#endregion
//#region src/lib/hooks/useDataTable.ts
var ze = {};
function Be(e) {
	let t = i(() => new URLSearchParams()), [n, a] = e.searchParams ?? t, o = {
		defaultSort: e.defaultSort,
		filters: e.filters ?? ze,
		sortableIds: X(e.columns)
	}, s = Fe(n, o), c = e.pageSize ?? 10, l = Ce(s, o.filters);
	function u(e) {
		a((t) => Re(t, e, o));
	}
	function d(e, t) {
		u(ye(s, e, t));
	}
	function f(e) {
		u(be(s, e));
	}
	function p(e) {
		u(xe(s, e));
	}
	function m() {
		u(Se(s, o.filters));
	}
	let h = {
		config: e,
		hasActiveFilters: l,
		pageSize: c,
		resetFilters: m,
		setFilter: d,
		setPage: p,
		setSort: f,
		state: s
	}, g = r(h);
	g.current = h;
	let _ = r(null);
	_.current ??= Me(g);
	let { Filter: v, Frame: y, Table: b, Toolbar: x } = _.current;
	return {
		Filter: v,
		filters: s.filters,
		Frame: y,
		getStatus: (e) => Y(e, l),
		hasActiveFilters: l,
		page: s.page,
		requestParams: we(s, c),
		resetFilters: m,
		setFilter: d,
		setPage: p,
		setSort: f,
		sort: s.sort,
		Table: b,
		Toolbar: x
	};
}
//#endregion
export { N as DATA_TABLE_COMMON_NAMESPACE, D as customFilter, Be as useDataTable, R as useDataTableTranslation };
